import { Auth } from '@mdlinx/shared';
import { useMDLPortal } from '../contexts/portal';
import * as React from 'react';

const { useEffect } = React;

const Root: React.FC = ({ children }) => {
  const Portal = useMDLPortal();
  return Portal && <Portal>{children}</Portal>;
};

interface LogoutHandlerProps {
  authBaseUrl: string;
  setInProgress: (inProgress: boolean) => void;
  inProgress: boolean;
  onLogoutSucceeded: () => void;
  onLogoutFailed: () => void;
}

export const LogoutHandler = ({
  authBaseUrl,
  onLogoutFailed,
  onLogoutSucceeded,
  inProgress = false,
  setInProgress,
}: LogoutHandlerProps) => {
  useEffect(() => {
    const handleIframeMessage = (event: MessageEvent) => {
      if (event.origin !== new URL(authBaseUrl).origin) {
        // Message from another iframe
        return;
      }
      if (!Auth.isLogoutResult(event.data)) {
        // Message not relevant to this component
        return;
      }

      switch (event.data) {
        case Auth.logoutSucceeded: {
          onLogoutSucceeded();
          setInProgress(false);
          return;
        }
        case Auth.logoutFailed: {
          onLogoutFailed();
          setInProgress(false);
          return;
        }
      }
    };

    window.addEventListener('message', handleIframeMessage);

    return function cleanup() {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, [onLogoutSucceeded, onLogoutFailed]);

  return (
    <>
      {inProgress && (
        <Root>
          <iframe
            src={`${authBaseUrl}/#logout`}
            style={{
              position: 'absolute',
              top: '-1px',
              left: '-1px',
              width: '1px',
              height: '1px',
              border: 'none',
            }}
            sandbox="allow-scripts allow-popups allow-forms allow-same-origin"
          />
        </Root>
      )}
    </>
  );
};
